<template>
  <div class="database-container">
    <a-card class="content-card">
      <div class="filter-section">
        <div class="filter-row">
          <div class="filter-item">
            <span class="filter-label">{{ translate('static.selectCountry') }}</span>
            <a-select :placeholder="translate('static.selectCountry')" show-search filterable v-model="formData.country" class="filter-select">
              <a-select-option
                v-for="item in countryOptions"
                :value="item.countryCode"
                :key="item.id"
              >
                {{ getCountryLabel(item) }}
              </a-select-option>
            </a-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">{{ translate('static.enterIP') }}</span>
            <!-- 【修改】a-input 改为 a-textarea，支持多IP输入 -->
            <a-textarea v-model="formData.ipport" :placeholder="translate('static.enterIPTip')" :auto-size="{ minRows: 1, maxRows: 4 }" class="filter-input" />
          </div>
          <div class="filter-item">
            <span class="filter-label">{{ translate('static.remark') }}</span>
            <a-input v-model="formData.remark" :placeholder="translate('static.remark')" class="filter-input" />
          </div>
          <div class="filter-item filter-actions">
            <a-button type="primary" @click="onSubmit" class="action-btn search-btn">
              {{ translate('child.header.title0') }}
            </a-button>
            <a-button type="default" @click="resetForm" class="action-btn">
              {{ translate('static.reset') }}
            </a-button>
          </div>
        </div>
        
        <div class="filter-row">
          <div class="filter-item">
            <span class="filter-label">{{ translate('static.ipStatus') }}</span>
            <a-select :placeholder="translate('static.ipStatus')" class="filter-select" v-model="formData.ipStatus">
              <!-- <a-select-option value="">{{ translate('static.all') }}</a-select-option> -->
              <a-select-option :value="1">{{ translate('static.unexpired') }}</a-select-option>
              <a-select-option :value="2">{{ translate('static.expired') }}</a-select-option>
            </a-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">{{ translate('static.proxyFormat') }}</span>
            <a-select :placeholder="translate('static.proxyFormat')" class="filter-select" @change="changeProxy">
              <a-select-option
                v-for="item in formatList"
                :value="item.dictCode"
                :key="item.dictCode"
              >
                {{ item.dictValue }}
              </a-select-option>
            </a-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">{{ translate('static.proxyType') }}</span>
            <a-select :placeholder="translate('static.proxyType')" class="filter-select" @change="changeNative" v-model="formData.nativeType">
              <a-select-option value="0" key="0">{{ translate('static.broadcast') }}</a-select-option>
              <a-select-option value="1" key="1">{{ translate('static.native') }}</a-select-option>
            </a-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">{{ translate('static.expirationRange') }}</span>
            <a-range-picker
              v-model="overTimeRange"
              :placeholder="[translate('static.startDate'), translate('static.endDate')]"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              class="filter-datepicker"
              @change="onOverTimeRangeChange"
            />
          </div>
          <div class="filter-item filter-actions">
            <a-button type="success" @click="downloadTxt" class="action-btn">
              {{ translate('static.batchExport') }}
            </a-button>
            <a-popconfirm
              :title="translate('static.confirmRenewal')"
              @confirm="onConfirmadd(2)"
            >
              <a-button
                type="danger"
                :disabled="dcids.length === 0"
                class="action-btn"
              >
                {{ translate('static.batchRenewal') }}
              </a-button>
            </a-popconfirm>
            <a-button
              type="primary"
              :disabled="dcids.length === 0"
              @click="batchChangePassword"
              class="action-btn"
            >
              {{ translate('static.batchChangeAccount') }}
            </a-button>
            <!-- 批量备注按钮 -->
            <a-button
              type="default"
              :disabled="dcids.length === 0"
              @click="openBatchRemark"
              class="action-btn"
            >
              {{ translate('static.batchRemark') }}
            </a-button>
          </div>
        </div>
      </div>

      <div v-if="isMobile" class="mobile-table-tip">
        <a-icon type="swap" />
        <span>{{ translate('static.swipeTableTip') }}</span>
      </div>

      <a-table
        v-if="flag"
        :data-source="dataList"
        :columns="columns"
        :rowKey="rowKey"
        :hover="hover"
        :loading="dataLoading"
        :pagination="pagination"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
        class="data-table"
        :scroll="{ x: 1500 }"
      >
        <template slot="overTime" slot-scope="text">
          <span :style="{ color: isExpired(text) ? '#f5222d' : (isExpiringSoon(text) ? '#faad14' : '') }">
            {{ text }}
            <a-tooltip v-if="isExpired(text)" :title="translate('static.expired')">
              <a-icon type="close-circle" style="color: #f5222d; margin-left: 4px;" />
            </a-tooltip>
            <a-tooltip v-else-if="isExpiringSoon(text)" :title="translate('static.expiringSoon')">
              <a-icon type="warning" style="color: #faad14; margin-left: 4px;" />
            </a-tooltip>
          </span>
        </template>
        <template slot="operation" slot-scope="text, row">
          <a-button size="small" type="primary" @click="renewal(row)" class="table-btn">{{ translate('static.renewal') }}</a-button>
          <a-button size="small" type="success" @click="daochu(row)" class="table-btn">{{ translate('static.export') }}</a-button>
          <a-button size="small" type="default" @click="addRemark(row)" class="table-btn">{{ translate('static.remark') }}</a-button>
          <!-- 修改账密 -->
          <a-button size="small" type="danger" @click="changePassword(row)" class="table-btn">{{ translate('static.changeAccount') }}</a-button>
          <a-button size="small" type="primary" @click="showQrCode(row)" class="table-btn">{{ translate('static.generateQrCode') }}</a-button>
          <!-- 自动续费 -->
          <div style="display: inline-flex; align-items: center; margin-left: 8px;">
            <span style="font-size: 12px; margin-right: 4px;">{{ translate('static.autoRenewal') }}</span>
            <a-switch 
              size="small"
              :checked="row.autoRenewalFlag === 1" 
              @change="(checked) => toggleRowAutoRenewal(row, checked)" 
            />
          </div>
        </template>
      </a-table>
      <a-spin v-else-if="!flag" style="display: flex" />
      
      <a-modal
        :visible.sync="visible"
        width="400px"
        :title="translate('static.renewal')"
        @ok="onConfirmadd(1)"
        @cancel="close"
        class="custom-modal"
      >
        <a-form labelAlign="left" :model="formdataBuy" :rules="rules" ref="form">
          <a-form-item :label="translate('static.purchaseDuration')" name="num">
            <a-radio-group v-model="formdataBuy.num" @change="changeTimelen">
              <a-radio-button value="30">{{ translate('static.thirtyDays') }}</a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-form>
      </a-modal>
      
      <a-modal
        :visible.sync="visibleRemark"
        width="400px"
        :title="translate('static.remark')"
        @ok="remarkChange"
        @cancel="remarkchose"
        class="custom-modal"
      >
        <a-form labelAlign="left" :model="formdataRemark" ref="formRemark">
          <a-form-item :label="translate('static.remark')" name="remark">
            <a-input v-model="formdataRemark.remark" :placeholder="translate('static.enterRemark')" />
          </a-form-item>
        </a-form>
      </a-modal>

      <!-- 批量备注弹窗 -->
      <a-modal
        :visible.sync="visibleBatchRemark"
        width="400px"
        :title="translate('static.batchRemark')"
        @ok="batchRemarkChange"
        @cancel="closeBatchRemark"
        class="custom-modal"
      >
        <a-form labelAlign="left" :model="batchRemarkForm" ref="formBatchRemark">
          <a-form-item :label="translate('static.remark')">
            <a-textarea v-model="batchRemarkForm.remark" :placeholder="translate('static.enterBatchRemark')" :auto-size="{ minRows: 2, maxRows: 6 }" />
          </a-form-item>
        </a-form>
        <div style="color: #999; font-size: 12px; margin-top: -8px;">
          {{ translate('static.batchRemarkTip', { count: dcids.length }) }}
        </div>
      </a-modal>

      <!-- 修改账密弹窗 -->
      <a-modal
        :visible.sync="visiblePassword"
        width="400px"
        :title="translate('static.changeAccount')"
        @ok="changePasswordSubmit"
        @cancel="closePassword"
        class="custom-modal"
      >
        <a-form-model labelAlign="left" :model="formdataPassword" :rules="rulesPassword" ref="formPassword">
          <a-form-model-item :label="translate('static.username')" prop="userName">
            <a-input v-model="formdataPassword.userName" :placeholder="translate('static.enterUsername')" />
          </a-form-model-item>
          <a-form-model-item :label="translate('static.proxyPassword')" prop="password">
            <a-input v-model="formdataPassword.password" :placeholder="translate('static.enterPassword')" />
          </a-form-model-item>
        </a-form-model>
      </a-modal>

      <!-- 二维码弹窗 -->
      <a-modal
        :visible.sync="visibleQrCode"
        width="400px"
        :title="translate('static.generateQrCode')"
        @cancel="visibleQrCode = false"
        :footer="null"
        class="custom-modal"
      >
        <div style="text-align: center; padding: 10px 0;">
          <div style="margin-bottom: 24px;">
            <span style="margin-right: 12px; font-weight: 500;">{{ translate('static.protocolType') }}:</span>
            <a-radio-group v-model="qrCodeProtocol" @change="generateQrCodeUrl">
              <a-radio-button value="shadowrocket">Shadowrocket</a-radio-button>
              <a-radio-button value="socks5">Socks5</a-radio-button>
            </a-radio-group>
          </div>
          <div style="display: flex; justify-content: center; margin-bottom: 20px;">
            <qrcode-vue :value="qrCodeUrl" :size="200" level="L" />
          </div>
          <div style="background: #f5f7fa; padding: 12px; border-radius: 8px; text-align: left;">
            <div style="font-size: 12px; color: #999; margin-bottom: 4px;">{{ translate('static.connectionInfo') }}</div>
            <div style="font-size: 14px; color: #333; word-break: break-all; font-weight: 500;">
              {{ maskConnectionInfoRow(currentQrCodeRow) }}
            </div>
          </div>
        </div>
      </a-modal>
    </a-card>
  </div>
</template>
<script>
import Clipboard from 'clipboard';
import { saveAs } from 'file-saver';
import QrcodeVue from 'qrcode-vue';

export default {
  name: 'StaticNux',
  components: {
    QrcodeVue
  },
  inject: ['languageState'],
  computed: {
    currentLanguage() {
      return this.languageState ? this.languageState.languageCode : 'en';
    },
    columns() {
      const columns = [
        {
          title: '',
          type: 'selection',
          width: 50,
          fixed: 'left',
          key: 'selection',
        },
        {
          title: this.translate('static.userId'),
          fixed: 'left',
          width: 80,
          align: 'left',
          ellipsis: true,
          dataIndex: 'uid',
          key: 'uid',
        },
        {
          title: this.translate('static.username'),
          width: 120,
          ellipsis: true,
          dataIndex: 'uname',
          key: 'uname',
        },
        {
          title: this.translate('static.proxyPassword'),
          width: 120,
          ellipsis: true,
          dataIndex: 'upassword',
          key: 'upassword',
        },
        {
          title: this.translate('static.connectionAddress'),
          width: 150,
          ellipsis: true,
          dataIndex: 'host',
          key: 'host',
        },
        {
          title: this.translate('static.port'),
          width: 100,
          ellipsis: true,
          dataIndex: 'port',
          key: 'port',
        },
        {
          title: this.translate('static.creationTime'),
          width: 150,
          ellipsis: true,
          dataIndex: 'creatTime',
          key: 'creatTime',
        },
        {
          title: this.translate('static.expirationTime'),
          width: 180,
          ellipsis: true,
          dataIndex: 'overTime',
          key: 'overTime',
          scopedSlots: { customRender: 'overTime' },
        },
        {
          title: this.translate('static.ipLocation'),
          width: 100,
          ellipsis: true,
          dataIndex: 'iso',
          key: 'iso',
        },
        {
          title: this.translate('static.remark'),
          dataIndex: 'remark',
          key: 'remark',
          customRender: (text) => {
            return {
              children: text,
              attrs: {
                style: 'word-break: break-all; white-space: normal; min-width: 150px;',
              },
            };
          },
        },
        {
          title: this.translate('static.operation'),
          width: 600,
          fixed: 'right',
          align: 'center',
          key: 'operation',
          scopedSlots: { customRender: 'operation' },
        },
      ];

      if (!this.isMobile) {
        return columns;
      }

      // 手机端优先展示连接地址，并移除固定列，避免宽操作列覆盖表格主体。
      const mobileColumnOrder = [
        'host',
        'port',
        'uname',
        'upassword',
        'uid',
        'creatTime',
        'overTime',
        'iso',
        'remark',
        'operation',
      ];

      return mobileColumnOrder.map((key) => {
        const column = columns.find((item) => item.key === key);
        return {
          ...column,
          fixed: undefined,
          width: key === 'operation' ? 520 : column.width,
        };
      });
    },
  },
  data() {
    return {
      isMobile: window.innerWidth <= 768,
      uid: localStorage.getItem('userId'),
      visible: false,
      visibles: false,
      value: 'dtzz',
      StateName: '',
      CityName: '',
      formData: {
        country: '',
        packageType: 'jtzz',
        pageNum: 1,
        pageSize: 10,
        ipport: '',
        ipportList: [],
        nativeType: '1',
        remark: '',
        userType: 'proxylink',
        overTimeStart: '',
        overTimeEnd: '',
        ipStatus: 1,
      },
      overTimeRange: null,
      formdataBuy: {
        num: '',
        cids: [],
      },
      rules: {
        num: [{ required: true, message: '请选择购买时长', type: 'error' }],
      },
      formatid: '',
      selectedMode: 0,
      life: 5,
      listnum: 10,
      citycode: '',
      state: '',
      dyType: '',
      country: 'US',

      rowKey: 'cid',
      dataLoading: false,
      hover: true,
      pagination: {
        defaultPageSize: 10,
        total: 0,
        defaultCurrent: 1,
        current: 1,
        showTotal: (total) => this.translate('static.total', { total }),
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100', '200', '500'],
      },
      dataList: [],
      priceList: [],
      IsoCodeList: [],
      ProxyContant: '',
      flow: '',
      flowoverdue: '',
      timer: null,
      countryOptions: [],
      formatList: [],
      proxyType: null,
      dcid: null,
      dcids: [],
      selectedRowKeys: [],
      flag: false,
      visibleRemark: false,
      visiblePassword: false,
      formdataPassword: {
        userName: '',
        password: '',
        proxyIds: []
      },
      rulesPassword: {
        userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      remark: '',
      formdataRemark: {
        remark: '',
        cid: '',
      },
      cidToUpidMap: {},
      autoRenewalFlag: 0,
      visibleQrCode: false,
      qrCodeProtocol: 'shadowrocket',
      qrCodeUrl: '',
      currentQrCodeRow: null,
      // 批量备注相关
      visibleBatchRemark: false,
      batchRemarkForm: {
        remark: '',
      },
    };
  },
  mounted() {
    this.getlist();
    this.getCountry();
    this.getFormatList();
    this.getAutoRenewalStatus();
    window.addEventListener('resize', this.handleViewportChange);
  },
  methods: {
    handleViewportChange() {
      this.isMobile = window.innerWidth <= 768;
    },

    getCountryLabel(item) {
      if (!item) return '';
      if (this.currentLanguage === 'zh') {
        return item.countryZh || item.country || item.countryName || item.countryCode;
      }
      return item.country || item.countryEn || item.countryName || item.countryCode;
    },

    translate(key, params = {}) {
      const lang = this.currentLanguage;
      const translations = {
        'static.total': lang === 'zh' ? `共 ${params.total} 条` : `Total ${params.total} items`,
        'child.header.title0': lang === 'zh' ? '搜索' : 'Search',
        'static.selectCountry': lang === 'zh' ? '请选择国家' : 'Please select a country',
        'static.reset': lang === 'zh' ? '重置' : 'Reset',
        'static.enterIP': lang === 'zh' ? '请输入ip' : 'Please enter IP',
        'static.enterIPTip': lang === 'zh' ? '请输入IP，多个IP请换行输入' : 'Enter IP, multiple IPs separated by new lines',
        'static.proxyFormat': lang === 'zh' ? '代理链接格式' : 'Proxy Link Format',
        'static.proxyType': lang === 'zh' ? '代理类型' : 'Proxy Type',
        'static.broadcast': lang === 'zh' ? '广播' : 'Broadcast',
        'static.native': lang === 'zh' ? '原生' : 'Native',
        'static.batchExport': lang === 'zh' ? '批量导出' : 'Batch Export',
        'static.export': lang === 'zh' ? '导出' : 'Export',
        'static.remark': lang === 'zh' ? '备注' : 'Remark',
        'static.batchRemark': lang === 'zh' ? '批量备注' : 'Batch Remark',
        'static.batchRemarkTip': lang === 'zh' ? `将为选中的 ${params.count} 条记录设置相同的备注` : `Will set the same remark for ${params.count} selected records`,
        'static.enterBatchRemark': lang === 'zh' ? '请输入批量备注内容' : 'Please enter batch remark',
        'static.changeAccount': lang === 'zh' ? '修改账密' : 'Change Account',
        'static.batchChangeAccount': lang === 'zh' ? '批量修改账密' : 'Batch Change Account',
        'static.autoRenewal': lang === 'zh' ? '自动续费' : 'Auto Renewal',
        'static.autoRenewalTip': lang === 'zh' ? '系统将会在线路过期前24小时自动扣费' : 'The system will automatically deduct fees 24 hours before the line expires',
        'static.cancelAutoRenewal': lang === 'zh' ? '取消自动续费' : 'Cancel Auto Renewal',
        'static.on': lang === 'zh' ? '开' : 'ON',
        'static.off': lang === 'zh' ? '关' : 'OFF',
        'static.confirmRenewal': lang === 'zh' ? '是否确认续费？' : 'Confirm renewal?',
        'static.batchRenewal': lang === 'zh' ? '批量续费' : 'Batch Renewal',
        'static.renewal': lang === 'zh' ? '续费' : 'Renewal',
        'static.purchaseDuration': lang === 'zh' ? '购买时长:' : 'Purchase Duration:',
        'static.thirtyDays': lang === 'zh' ? '30天' : '30 Days',
        'static.enterRemark': lang === 'zh' ? '请输入备注' : 'Please enter remark',
        'static.userId': lang === 'zh' ? '用户id' : 'User ID',
        'static.username': lang === 'zh' ? '用户名' : 'Username',
        'static.proxyPassword': lang === 'zh' ? '代理密码' : 'Proxy Password',
        'static.connectionAddress': lang === 'zh' ? '连接地址' : 'Connection Address',
        'static.port': lang === 'zh' ? '端口号' : 'Port',
        'static.creationTime': lang === 'zh' ? '创建时间' : 'Creation Time',
        'static.expirationTime': lang === 'zh' ? '到期时间' : 'Expiration Time',
        'static.ipLocation': lang === 'zh' ? 'ip归属地' : 'IP Location',
        'static.operation': lang === 'zh' ? '操作' : 'Operation',
        'static.enterUsername': lang === 'zh' ? '请输入用户名' : 'Please enter username',
        'static.enterPassword': lang === 'zh' ? '请输入密码' : 'Please enter password',
        'static.ipStatus': lang === 'zh' ? 'IP状态' : 'IP Status',
        'static.unexpired': lang === 'zh' ? '未过期' : 'Unexpired',
        'static.all': lang === 'zh' ? '全部' : 'All',
        'static.expiringSoon': lang === 'zh' ? '即将到期(1天内)' : 'Expiring soon (within 1 day)',
        'static.expired': lang === 'zh' ? '已到期' : 'Expired',
        'static.generateQrCode': lang === 'zh' ? '二维码' : 'QR Code',
        'static.protocolType': lang === 'zh' ? '协议类型' : 'Protocol Type',
        'static.connectionInfo': lang === 'zh' ? '连接信息' : 'Connection Info',
        'static.expirationRange': lang === 'zh' ? '到期时间范围' : 'Expiration Range',
        'static.startDate': lang === 'zh' ? '开始日期' : 'Start date',
        'static.endDate': lang === 'zh' ? '结束日期' : 'End date',
        'static.swipeTableTip': lang === 'zh' ? '左右滑动查看完整列表' : 'Swipe horizontally to view all columns',
      };
      return translations[key] || key;
    },
    handleTableChange(pagination) {
      this.formData.pageNum = pagination.current;
      this.formData.pageSize = pagination.pageSize;
      this.getlist();
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
      this.dcids = selectedRowKeys;
    },
    onSubmit() {
      this.flag = false;
      this.formData.pageNum = 1;
      this.getlist();
    },
    resetForm() {
      this.formData = {
        country: '',
        packageType: 'jtzz',
        pageNum: 1,
        pageSize: 10,
        ipport: '',
        ipportList: [],
        nativeType: '1',
        remark: '',
        userType: 'proxylink',
        overTimeStart: '',
        overTimeEnd: '',
        ipStatus: 1,
      };
      this.overTimeRange = null;
    },
    onOverTimeRangeChange(dates) {
      if (dates && dates.length === 2) {
        this.formData.overTimeStart = dates[0];
        this.formData.overTimeEnd = dates[1];
      } else {
        this.formData.overTimeStart = '';
        this.formData.overTimeEnd = '';
      }
    },
    getCountry() {
      this.$request.get('/userIntegral/getNuxCountryList').then((res) => {
        if (res.data.code === 200) {
          this.countryOptions = res.data.data;
        }
      });
    },
    getCountryOther() {
      this.$request.get('/userIntegral/getNuxCountryListCast').then((res) => {
        if (res.data.code === 200) {
          this.countryOptions = res.data.data;
        }
      });
    },
    getlist() {
      const payload = { ...this.formData, uid: this.uid };
      
      if (this.formData.ipport && this.formData.ipport.trim()) {
        const ips = this.formData.ipport.trim().split(/[\n,;]+/).map(s => s.trim()).filter(Boolean);
        if (ips.length > 1) {
          payload.ipportList = ips;
          payload.ipport = '';
        } else {
          payload.ipportList = [];
          payload.ipport = ips[0];
        }
      } else {
        payload.ipportList = [];
        payload.ipport = '';
      }

      this.$request
        .post('/consum/getProxyStaticListNewWithNux', payload)
        .then((res) => {
          if (res.data.code === 200) {
            const list = res.data.result.list;
            list.forEach(item => {
              this.$set(this.cidToUpidMap, item.cid, item.upid);
              this.$set(item, 'autoRenewalFlag', 0);
              
              this.$request.get(`/ums/user/getAutoRenewalStatic?cid=${item.cid}`)
                .then(autoRes => {
                  if (autoRes.data.code === 200) {
                    item.autoRenewalFlag = autoRes.data.data ? 1 : 0;
                  }
                })
                .catch(e => console.log(e));
            });
            this.dataList = list;
            this.pagination = {
              ...this.pagination,
              defaultPageSize: res.data.result.pageSize,
              total: res.data.result.total,
              defaultCurrent: res.data.result.pageNum,
              current: res.data.result.pageNum,
            };
          } else {
            this.dataList = [];
            this.pagination = {
              ...this.pagination,
              defaultPageSize: 10,
              total: 0,
              defaultCurrent: 1,
              current: 1,
            };
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.flag = true;
          this.dataLoading = false;
        });
    },
    getTimelen() {
      this.$request.get('/userIntegral/getDictPackagePrice').then((res) => {
        this.priceList = res.data;
      });
    },
    getFormatList() {
      this.$request
        .get('/consum/getFormatList')
        .then((res) => {
          if (res.data.code === 200) {
            this.formatList = res.data.data;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    changeTimelen(e) {
      this.formdataBuy.num = e.target.value;
    },
    renewal(row) {
      this.formdataBuy.cids = [row.cid];
      this.visible = true;
    },
    daochu(row) {
      this.dcid = row.cid;
      let params = {};
      params = { ids: [this.dcid], formatid: this.proxyType };
      this.$request
        .post('/userIntegral/exportConsumInfo', params)
        .then((res) => {
          if (res.data.code === 200) {
            let str = res.data.data;
            let strData = new Blob([str], { type: 'text/plain;charset=utf-8' });
            saveAs(strData, 'proxylink_' + new Date().toLocaleDateString() + '.txt');
          } else {
            this.$message.warning(res.data.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    addRemark(row) {
      this.formdataRemark.remark = row.remark;
      this.dcid = row.cid;
      this.visibleRemark = true;
    },
    remarkChange() {
      this.formdataRemark.cid = this.dcid;
      this.$request
        .post('/consum/updateRemark', this.formdataRemark)
        .then((res) => {
          if (res.data.code === 200) {
            this.visibleRemark = false;
            this.getlist();
            this.$message.success('修改成功');
          } else {
            this.$message.warning(res.data.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    remarkchose() {
      this.visibleRemark = false;
    },
    // ===== 批量备注 =====
    openBatchRemark() {
      this.batchRemarkForm.remark = '';
      this.visibleBatchRemark = true;
    },
    batchRemarkChange() {
      if (!this.batchRemarkForm.remark && this.batchRemarkForm.remark !== '') {
        this.$message.warning(this.currentLanguage === 'zh' ? '请输入备注内容' : 'Please enter remark');
        return;
      }
      this.$request
        .post('/consum/batchUpdateRemark', {
          cids: this.dcids,
          remark: this.batchRemarkForm.remark,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.visibleBatchRemark = false;
            this.selectedRowKeys = [];
            this.dcids = [];
            this.getlist();
            this.$message.success(this.currentLanguage === 'zh' ? '批量备注成功' : 'Batch remark successful');
          } else {
            this.$message.warning(res.data.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    closeBatchRemark() {
      this.visibleBatchRemark = false;
      this.batchRemarkForm.remark = '';
    },
    // ===== 批量备注 END =====
    changePassword(row) {
      this.formdataPassword.proxyIds.push(row.upid);
      this.visiblePassword = true;
    },
    changePasswordSubmit() {
      this.$refs["formPassword"].validate((valid) => {
        if (valid) {
          this.$request
            .post('/userIntegral/updateUserNameAndPassword', this.formdataPassword)
            .then((res) => {
              console.log(res);
              
              if (res.data.code === 200) {
                this.getlist();
                this.selectedRowKeys = [];
                this.dcids = [];
                this.$message.success('修改成功');
              } else {
                this.$message.warning(res.data.msg);
              }
            })
            .catch((e) => {
              console.log(e);
            })
            .finally(() => {
              this.visiblePassword = false;
              this.formdataPassword = {
                userName: '',
                password: '',
                proxyIds: []
              };
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    closePassword() {
      this.visiblePassword = false;
      this.formdataPassword = {
        userName: '',
        password: '',
        proxyIds: []
      };
    },
    batchChangePassword() {
      if (this.dcids.length === 0) return;
      const upids = this.dcids.map(cid => this.cidToUpidMap[cid]).filter(upid => upid);
      
      if (upids.length > 0) {
        this.formdataPassword.proxyIds = upids;
        this.visiblePassword = true;
      }
    },
    deleted(row) {
      console.log(row);
    },
    renewWithMore() {
      this.visibles = true;
    },
    onVisibleChange(val, context = {}) { 
      if (context && context.trigger === 'confirm') {
        this.onConfirmadd(2);
      } else {
        this.visible = false;
      }
    },
    onConfirmadd(e) {
      if (e === 2) {
        this.formdataBuy.cids = this.dcids;
        this.formdataBuy.num = "30";
      }
      this.$request
        .post('/userIntegral/pointRenewalNuxPackage', this.formdataBuy)
        .then((res) => {
          if (res.data.code === 200) {
            this.getlist();
            this.visible = false;
            this.$message.success('续费成功');
            this.formdataBuy = {};
          } else {
            this.$message.warning(res.data.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    close() {
      this.visible = false;
      this.formdataBuy = {};
    },
    downloadTxt() {
      let params = {};
      params = { ids: this.dcids, formatid: this.proxyType, nativeType: this.formData.nativeType };
      this.$request
        .post('/userIntegral/exportConsumInfo', params)
        .then((res) => {
          if (res.data.code === 200) {
            let str = res.data.data.join('\n');
            let strData = new Blob([str], { type: 'text/plain;charset=utf-8' });
            saveAs(strData, 'proxylink_' + new Date().toLocaleDateString() + '.txt');
          } else {
            this.$message.warning(res.data.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    changeProxy(e) {
      this.proxyType = e;
    },
    changeNative(e) {
      this.formData.nativeType = e;
      if (this.formData.nativeType == 1) {
        this.getCountry();
      } else {
        this.getCountryOther();
      }
      this.flag = false;
      this.getlist();
    },
    getLoginStatus() {
      this.$request
        .get('/ums/isLoginStates')
        .then((res) => {
          if (res.data.code === 5000) {
            this.$router.push('/login');
            window.localStorage.clear();
            this.$message.warning('请重新登录！');
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getAutoRenewalStatus() {
      this.$request.get('/ums/user/getAutoRenewal').then((res) => {
        if (res.data.code === 200 && res.data.data) {
          this.autoRenewalFlag = res.data.data.flag;
        }
      }).catch((e) => {
        console.log(e);
      });
    },
    toggleAutoRenewal(checked) {
      const flag = checked ? 1 : 0;
      const title = checked 
        ? (this.currentLanguage === 'zh' ? '是否确认开启自动续费？' : 'Confirm to enable auto-renewal?') 
        : (this.currentLanguage === 'zh' ? '是否确认关闭自动续费？' : 'Confirm to disable auto-renewal?');
      const content = checked 
        ? (this.currentLanguage === 'zh' ? '系统将会在线路过期前24小时自动扣费' : 'The system will automatically deduct fees 24 hours before the line expires') 
        : '';

      this.$confirm({
        title: title,
        content: content,
        onOk: () => {
          return this.$request.post(`/ums/user/updateAutoRenewal?flag=${flag}`, { flag }).then((res) => {
            if (res.data.code === 200) {
              this.$message.success(this.currentLanguage === 'zh' ? '设置成功' : 'Setting successful');
              this.autoRenewalFlag = flag;
            } else {
              this.$message.warning(res.data.msg);
            }
          }).catch((e) => {
            console.log(e);
          });
        },
        onCancel() {},
      });
    },
    toggleRowAutoRenewal(row, checked) {
      const title = checked 
        ? (this.currentLanguage === 'zh' ? '是否确认开启自动续费？' : 'Confirm to enable auto-renewal?') 
        : (this.currentLanguage === 'zh' ? '是否确认关闭自动续费？' : 'Confirm to disable auto-renewal?');
      const content = checked 
        ? (this.currentLanguage === 'zh' ? '系统将会在线路过期前24小时自动扣费' : 'The system will automatically deduct fees 24 hours before the line expires') 
        : '';

      this.$confirm({
        title: title,
        content: content,
        onOk: () => {
          return this.$request.post('/ums/user/updateAutoRenewalStatic', row).then((res) => {
            if (res.data.code === 200) {
              this.$message.success(this.currentLanguage === 'zh' ? '设置成功' : 'Setting successful');
              row.autoRenewalFlag = checked ? 1 : 0;
            } else {
              this.$message.warning(res.data.msg);
            }
          }).catch((e) => {
            console.log(e);
          });
        },
        onCancel() {},
      });
    },
    changeCodejt() {
      this.getProxyStaticList();
    },
    copy() {
      var clipboard = new Clipboard('#equSN');
      clipboard.on('success', () => {
        this.$message.success('已成功复制到粘贴板');
        clipboard.destroy();
      });
      clipboard.on('error', () => {
        this.$message.warning('该浏览器不支持复制');
        clipboard.destroy();
      });
    },
    isExpiringSoon(timeStr) {
      if (!timeStr) return false;
      const overTime = new Date(timeStr.replace(/-/g, '/')).getTime();
      const now = new Date().getTime();
      const diffDays = (overTime - now) / (1000 * 60 * 60 * 24);
      return diffDays > 0 && diffDays <= 1;
    },
    isExpired(timeStr) {
      if (!timeStr) return false;
      const overTime = new Date(timeStr.replace(/-/g, '/')).getTime();
      const now = new Date().getTime();
      return overTime <= now;
    },
    showQrCode(row) {
      this.currentQrCodeRow = row;
      this.generateQrCodeUrl();
      this.visibleQrCode = true;
    },
    generateQrCodeUrl() {
      if (!this.currentQrCodeRow) return;
      const row = this.currentQrCodeRow;
      const codeInfo = `${row.uname}:${row.upassword}@${row.host}:${row.port}`;
      let url_head = 'socks://';
      
      if (this.qrCodeProtocol === 'shadowrocket') {
        try {
          this.qrCodeUrl = url_head + btoa(unescape(encodeURIComponent(codeInfo)));
        } catch (e) {
          console.error('Base64 编码失败:', e);
          this.$message.error(this.currentLanguage === 'zh' ? '编码失败' : 'Encoding failed');
        }
      } else {
        this.qrCodeUrl = url_head + codeInfo;
      }
    },
    maskConnectionInfoRow(row) {
      if (!row) return '-';
      return `${row.uname}:****@${row.host}:${row.port}`;
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleViewportChange);
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
};
</script>
<style scoped lang="less">
/* 基础容器 */
.database-container {
  padding: 24px;
  background: #f5f5f5;
  min-height: 100%;
}

/* 卡片样式 */
.content-card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  background: #fff;
  border: 1px solid #f0f0f0;
}

/* 筛选区域 */
.filter-section {
  padding: 20px 24px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

/* 筛选行 */
.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

/* 筛选项 */
.filter-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 180px;
  flex: 1;
}

/* 按钮组 */
.filter-actions {
  flex-direction: row;
  align-items: flex-end;
  gap: 12px;
  min-width: auto;
  flex-wrap: wrap;
}

/* 筛选标签 */
.filter-label {
  font-size: 14px;
  font-weight: 600;
  color: #595959;
  letter-spacing: 0.5px;
}

/* 下拉选择框 */
.filter-select {
  width: 100%;
}

/* 输入框 */
.filter-input {
  width: 100%;
}

/* 日期范围选择器样式 */
.filter-datepicker {
  width: 100%;
}

/* 操作按钮 */
.action-btn {
  height: 36px;
  font-size: 14px;
  font-weight: 500;
  padding: 0 20px;
  border-radius: 8px !important;
  line-height: 36px !important;
}

/* 输入框和下拉框 */
.filter-select,
input.filter-input {
  height: 36px !important;
}

:deep(.ant-select-selector) {
  height: 36px !important;
  line-height: 36px !important;
}

:deep(input.ant-input) {
  height: 36px !important;
  line-height: 36px !important;
}

:deep(textarea.ant-input) {
  min-height: 36px !important;
  line-height: 1.5 !important;
  padding-top: 6px;
  padding-bottom: 6px;
  resize: none !important;
}

/* 日期选择器内部高度统一 */
:deep(.ant-calendar-picker-input),
:deep(.ant-range-picker) {
  height: 36px !important;
}

:deep(.ant-calendar-picker) {
  width: 100%;
}

/* 表格样式 */
.data-table {
  margin-top: 20px;
  border-radius: 12px;
  border: 1px solid #f0f0f0;
}

/* 表格按钮 */
.table-btn {
  margin-right: 8px;
  margin-bottom: 4px;
  border-radius: 6px !important;
  font-size: 12px;
  height: 28px;
  padding: 0 12px;
}

/* 弹窗样式 */
.custom-modal {
  :deep(.ant-modal-header) {
    border-radius: 12px 12px 0 0;
  }
  
  :deep(.ant-modal-content) {
    border-radius: 12px;
  }
}

.mobile-table-tip {
  display: none;
}

@media (max-width: 768px) {
  .database-container {
    padding: 0;
  }

  .content-card {
    border-radius: 8px;
  }

  .content-card /deep/ .ant-card-body {
    padding: 12px;
  }

  .filter-section {
    padding: 14px 12px;
    border-radius: 8px;
  }

  .filter-row {
    flex-direction: column;
    gap: 12px;
  }

  .filter-item {
    width: 100%;
    min-width: 0;
    flex: none;
  }

  .filter-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: stretch;
    gap: 10px;
  }

  .filter-actions .ant-btn,
  .filter-actions .ant-popover-wrapper,
  .filter-actions .ant-popover-wrapper .ant-btn {
    width: 100%;
  }

  .action-btn {
    height: auto;
    min-height: 40px;
    min-width: 0;
    padding: 6px 8px;
    line-height: 1.25 !important;
    white-space: normal;
  }

  .data-table {
    margin-top: 12px;
    border-radius: 8px;
    overflow: hidden;
  }

  .mobile-table-tip {
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 2px 0 8px;
    color: #8c8c8c;
    font-size: 12px;
  }

  .data-table /deep/ .ant-table-fixed-left,
  .data-table /deep/ .ant-table-fixed-right {
    display: none !important;
  }

  .data-table /deep/ .ant-table-body {
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-x pan-y;
  }
}
</style>
